import { DatedType } from "../types";

// by date descending
export const byDate = (a: DatedType, b: DatedType) => {
    return new Date(b.date_created).getTime() - new Date(a.date_created).getTime();
}
